import { Colors } from '../../theme/Colors';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

const StyledAnchor = styled(Link)({
    color: Colors.primary,
    backgroundColor: Colors.white,
    padding: '10px 20px',
    borderRadius: 25,
    fontWeight: 'bold',
    boxShadow: '#807E7D80 0px 3px 6px',
    '&:hover': {
        color: Colors.primary,
        textDecoration: 'none',
    },
    textAlign: 'center',
});

export default StyledAnchor;
